module.exports = __webpack_public_path__ + "img/1573623902.d1a7e08b.jpg";